import { instance } from './_config.js'



const getShipements = async (obj) => {
    try {
        const rs = await instance.post(`/shipments/search`, obj)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateShipement = async (obj) => {
    try {
        const rs = await instance.post(`shipments`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteShipement = async (id) => {
    try {
        const rs = await instance.delete(`shipments`, { data: { '_id': id }})
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getShipements, updateShipement, deleteShipement }